/**
 * The library import, for the organization's own System Admin.
 *
 * The same page StandingDocs uses in the console, pointed at the
 * organization this person is signed in to. It is theirs to run because it
 * now explains itself: the spreadsheet is checked line by line before
 * anything is uploaded, every choice says what it will do, the files are
 * matched before the run, a run can be rolled back, and a report says what
 * came in and what did not. The backend allows it for their own organization
 * only (functions/src/import/access.ts).
 */
import { useAuth } from '../../auth/useAuth';
import { ImportPage } from '../console/ImportPage';
import { AttestationImportPage } from '../console/AttestationImportPage';

export function LibraryImportPage() {
  const { session } = useAuth();
  if (!session?.orgId) return null;
  return <ImportPage orgId={session.orgId} home="app" />;
}

/** The attestation history import, for the same person and the same organization. */
export function LibraryAttestationImportPage() {
  const { session } = useAuth();
  if (!session?.orgId) return null;
  return <AttestationImportPage orgId={session.orgId} home="app" />;
}
